<template>
    <div class="eda-submit">

        <h1 class="eda-submit__heading">
            {{ $t('orderForm.heading') }}
        </h1>

        <div class="eda-submit__panes">

            <div class="eda-submit__pane">
                <form v-if="customer ">
                    <fieldset class="eda-submit__fieldset">

                        <h2 class="eda-submit__h2">
                            {{ $t('orderForm.customer.heading') }}
                        </h2>

                        <eda-styled-input v-model="customer.fullName"
                                          :label="$t('orderForm.customer.name')"
                                          name="customerName"
                                          validation="required|regex:^([a-zA-Z0-9ÆØÅæøå].+\s+[a-zA-Z0-9ÆØÅæøå].*)+$">
                        </eda-styled-input>

                        <eda-styled-input v-model="customer.phone"
                                          :label="$t('orderForm.customer.telephone')"
                                          name="customerTelephone"
                                          validation="required|min:5"
                                          input-mask="">
                        </eda-styled-input>

                        <eda-styled-input v-model="customer.email"
                                          :label="$t('orderForm.customer.email')"
                                          name="customerEmail"
                                          validation="required|email"
                                          input-mask="">
                        </eda-styled-input>

                    </fieldset>


                    <fieldset class="eda-submit__fieldset">

                        <h2 class="eda-submit__h2">
                            {{ $t('orderForm.installationAddress.heading') }}
                        </h2>


                        <eda-styled-input v-model="customer.addressLine1"
                                          name="customerAddressLine1"
                                          :label="$t('orderForm.installationAddress.addressLine1')"
                                          validation="required">
                        </eda-styled-input>


                        <div class="eda-submit__fieldgroup">
                            <div class="eda-submit__postcode">
                                <eda-styled-input v-model="customer.postCode"
                                                  name="customerPostCode"
                                                  :label="$t('orderForm.installationAddress.postCode')"
                                                  inputMask="####"
                                                  validation="digits:4|required">
                                </eda-styled-input>
                            </div>

                            <div class="eda-submit__place">
                                <eda-styled-input v-model="customer.place"
                                                  name="customerPlace"
                                                  :label="$t('orderForm.installationAddress.place')"
                                                  validation="required">
                                </eda-styled-input>
                            </div>
                        </div>


                    </fieldset>

                    <fieldset class="eda-submit__fieldset">
                        <h2 class="eda-submit__h2">
                            {{ $t('orderForm.houseApproved.heading') }}
                        </h2>
                        <eda-options
                                name="houseApproved"
                                validation="required"
                                v-model="customer.approvedByHouseOwner"
                                :options="[
                                {value: 'approved', label: $t('orderForm.houseApproved.approved')},
                                {value: 'rejected' , label: $t('orderForm.houseApproved.rejected')},
                                {value: 'n/a', label: $t('orderForm.houseApproved.na')}
                                ]"

                        ></eda-options>
                    </fieldset>

                    <fieldset class="eda-submit__fieldset">
                        <h2 class="eda-submit__h2">
                            {{ $t('orderForm.carDeliveryDate.heading') }}
                        </h2>


                        <eda-date-input
                                v-model="customer.carDeliveryDate"
                                :placeholder="$t('orderForm.carDeliveryDate.placeholder')"
                        ></eda-date-input>

                    </fieldset>


                </form>
            </div>

            <div class="eda-submit__pane">


                <div class="eda-submit__summary-header">

                    <h2 class="eda-order__h2">
                        {{ $t('order.summary.heading') }}
                    </h2>
                    <a @click="changeSolution()" class="eda-submit__change-solution">
                        {{ $t('orderForm.changeSolution') }}
                    </a>
                </div>

                <template v-for="line in orderLines">
                    <v-order-line v-bind="line" :show-price="true"></v-order-line>
                </template>


                <div class="eda-order__total">
                    {{ $t('order.summary.total') }}
                    <span class="eda-order__amount"> {{ total }},- </span>
                </div>

                <div class="eda-order__vat" v-if="totalVat">
                    {{ $t('order.summary.vat') }} <span class="eda-order__amount">{{ totalVat }},- </span>
                </div>

                <!--
                <div class="eda-submit__current-solution">

                    <v-solution-card v-bind="currentSolutionCardData"></v-solution-card>
                </div>
                -->


                <fieldset class="eda-submit__fieldset">
                    <h2 class="eda-submit__h2">
                        {{ $t('orderForm.retailer.heading') }}
                    </h2>

                    <eda-styled-input
                            name="retailerOrderRef"
                            :label="$t('orderForm.retailer.reference')"
                            v-model="order.retailerOrderRef"
                            validation="required|max:12"
                            :placeholder="$t('orderForm.retailer.reference')"
                    ></eda-styled-input>

                    <eda-styled-textarea
                            name="orderNotes"
                            :rows="2"
                            :label="$t('orderForm.retailer.details')"
                            v-model="order.orderNotes"
                            :placeholder="$t('orderForm.retailer.details')"
                    ></eda-styled-textarea>

                </fieldset>


                <eda-order-errors :errors="errors">

                </eda-order-errors>


                <div class="eda-submit__submit">

                    <eda-button :disabled="submitDisabled"
                                :loading="sendingSubmitAndCompleteRequest"
                                @click="submitAndComplete"
                                :label="$t('orderForm.submit')">
                    </eda-button>


                </div>


            </div>
        </div>
    </div>

</template>

<script>
  import EdaOptions from "../components/vOptions"
  import vSolutionCard from "../components/vCardSolution"
  import EdaButton from "../components/vButton"
  import EdaOrderErrors from "../components/vOrderErrors"
  import EdaDateInput from "../components/vDateInput"
  import EdaStyledInput from "../components/vInput"
  import EdaStyledTextarea from "../components/vTextarea"
  import vOrderLine from "../components/vOrderLine"
  import transformers from "../transformers/transformers"
  import { mapGetters } from "vuex"
  import { mapActions } from "vuex"
  import apiMixin from "../mixins/apiMixin.js"
  import axios from "axios"
  import _ from "lodash"

  export default {
    name: "EdaSubmitOrder",
    inject: ['$validator'],
    mixins: [
      apiMixin.apiMixin,
      transformers.solutionCardTransformer,
      transformers.orderToPost,
    ],
    components: {
      EdaOptions,
      EdaButton,
      EdaDateInput,
      EdaStyledInput,
      EdaStyledTextarea,
      EdaOrderErrors,
      vSolutionCard,
      vOrderLine,
    },
    data() {
      return {
        sendingSubmitAndCompleteRequest: false,
        sendingSubmitAndAccessorizeRequest: false,
        customer: {},
        order: {}
      };
    },

    created() {
      this.customer = this.getCustomer;
      this.order = this.getOrderState;
    },
    watch: {
      /* customer: {
      handler(val) {
      this.setCustomer(this.customer);
      },
      deep: true
      },
      */
      order: {

        handler(val) {
          this.setOrder(this.order);
        },
        deep: true
      },
      'customer.postCode'(val) {
        this.getPlace(val);
      }
    },
    computed: {
      ... mapGetters([
        "getOrderState",
        "getCurrentSolution",
        "getCustomer",
      ]),
      submitDisabled() {
        return this.errors.items.length ? true : false;
      }
      ,
      currentSolutionCardData() {

        return this.solutionCardTransform(this.getCurrentSolution, this.getCustomer.carModel);
      },

      orderLines() {
        return [...this.getOrderState.solution.baseProducts, ...this.getOrderState.addonProducts]
      },

      total() {
        let total = 0;

        if (this.order !== {}) {
          for (let i in this.orderLines) {
            total = total + this.orderLines[i].price;
          }
        }
        return total;
      },

      totalVat() {
        let vat = 0;

        for (let i in this.orderLines) {
          vat = vat + this.orderLines[i].vat;
        }
        return Math.round(vat);
      },

      hasAddonProducts() {
        let connector = this.getCustomer.carModel.connector.toLowerCase().replace(/ /g, '');
        return this.getCurrentSolution.addonProducts[connector].length ? true : false;
        return false;
      },

    },

    methods: {
      ...
        mapActions(
          ['setCustomer', 'clearOrderState', 'setOrder']
        ),

      changeSolution() {
        this.$router.push("/solutions/")
      },

      submitAndComplete() {
        this.sendingSubmitAndCompleteRequest = true;
        this.submitOrder("/orders/:id");
      }
      ,
      submitAndAccessorize() {

        this.$validator.validateAll().then(result => {
          if (result) {
            this.$router.push("/orders/new/accessories");
          }
        });
      },

      getPlace: function (zip) {

        var that = this;
        if (zip.length == 4) {
          axios.get("https://api.bring.com/shippingguide/api/postalCode.json", {
            params: { clientUrl: "https://www.salto.no", pnr: zip, }
          }).then(function (response) {
            that.customer.place = response.data.result
          }).catch(function (error) {
            console.log(error);
          });
        }
      },


      submitOrder(nextRoute) {
        var that = this;
        this.$validator.validateAll().then(result => {
          if (result) {
            let post = that.orderToPost(that.getOrderState);
            axios.post(process.env.VUE_APP_API_URL + "/orders", post, that.apiHeaders
            ).then(function (response) {
              let order = response.data;
              nextRoute = nextRoute.replace(":id", order.id);
              that.clearOrderState();
              that.$router.push(nextRoute);
            }).catch(function (error) {
              console.log(error);
            }).finally(function () {
              that.sendingSubmitAndCompleteRequest = false;
            });
          }
        })

      }

    }

  }
</script>

<style>

    .eda-submit__panes {
        justify-content: center;
        display: flex;
        width: 100%;
    }

    .mq-tablet .eda-submit__panes,
    .mq-mobile .eda-submit__panes {
        flex-direction: column;
        align-items: center;
    }

    .eda-submit__pane {
        margin: 0.1%;
        max-width: 33em;
        width: 49.9%;
        flex: none;
        padding: 2em 2em 4em 2em;
        background-color: white;
    }

    .mq-tablet .eda-submit__pane,
    .mq-mobile .eda-submit__pane {
        width: 100%;
    }

    .eda-submit__current-solution {
        width: 100%;
        max-width: 20em;
        margin: 0 auto;
    }

    .eda-submit__summary-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding-bottom: 1em;
        align-items: baseline;

    }

    .eda-submit__change-solution {
        cursor: pointer;
        display: block;
        color: #00B27C;
        font-size: 0.8em;
    }

    .eda-submit__heading {
        margin-bottom: 2em;
        font-weight: 500;
        width: 100%;
        text-align: center;
        color: white;
    }

    .eda-submit__h2 {
        margin-bottom: 0.5em;
        font-size: 1em;
        padding-left: 1.25em;
        font-weight: 600;
        color: #263926;
    }

    .eda-submit__submit {
        justify-content: center;
        display: flex;
        padding-top: 2em;
    }

    .eda-submit__fieldset {
        border: none;
        padding: 0.5em 0;
    }

    .eda-submit__fieldgroup {
        display: flex;
        justify-content: space-between;

    }

    .eda-submit__postcode {
        width: 45%;
    }

    .eda-submit__place {
        width: 53%;
    }

</style>
